var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [_c('section', {
    staticClass: "questionSection"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound && _vm.currentRound.questionHtml
    }
  })], 1), _c('section', {
    staticClass: "svgSection"
  }, [_c('span', {
    staticClass: "svgHtml",
    domProps: {
      "innerHTML": _vm._s(_vm.loadedSvg)
    }
  })]), _vm.showActivityNextSectionPortal ? _c('activity-next-section-portal', {
    attrs: {
      "handleOnActivitySubmit": _vm.handleOnActivitySubmit,
      "displayWrongIcon": _vm.displayWrongIcon,
      "displayCorrectIcon": _vm.displayCorrectIcon
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }